import { useExperiment } from '@cash-web/shared-data-access-experiments'

import { useFeatureFlag } from './useFeatureFlag'

export const useShowCardStudio = () => {
  const cardStudioEnabledByFeatureFlag = useFeatureFlag('cash-web-account-card-studio') === 'ENABLED'

  // If card studio is enabled for a customer by LD FF, we skip the experiment assignment to exclude them from the experiment
  const cardStudioEnabledByExperiment =
    useExperiment('cash-web-card-studio', cardStudioEnabledByFeatureFlag)?.variant_value === 'treatment'

  const cardStudioEnabled = cardStudioEnabledByFeatureFlag || cardStudioEnabledByExperiment

  const touchDevicesEnabled = useFeatureFlag('cash-web-account-enable-card-studio-touch-devices')

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  return Boolean(cardStudioEnabled && (!isTouchDevice || touchDevicesEnabled))
}
